export enum S3FileContent {
  PNG = 'image/png',
  JPEG = 'image/jpeg',
  MPEG = 'audio/mpeg',
  MP3 = 'audio/mp3',
  MP4 = 'audio/mp4',
}
